import React from 'react'
import { blue, red, yellow, green } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AppLink from '../../../../components/AppLink';
import { Invite, Contractor, Patient } from '../../../../models';
import dayjs from 'dayjs';
import ContractorListWidget from '../contractors/contractor-list.component';
import Centered from '../../../../components/Centered';
import PatientListWidget from '../patients/patients-list.component';
import { ROUTES } from '../../../../history';


const InviteView: React.FC<
    {
        invite: Invite;
    }
> = ({
    invite
}) => {
        const getColor = (): string => {
            let color: string;
            switch (invite.Status) {
                case "Accepted":
                    color = blue[700];
                    break;
                case "Rejected":
                    color = red[700];
                    break;
                case "Completed":
                    color = green[700];
                    break;
                default:
                    color = yellow[800]
                    break;
            }
            return color;

        }

        return (
            <Centered >
                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                    <Typography textAlign={'center'} fontWeight="bold"
                        component="h6" variant="h6">
                        {invite.Title}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={'14px'}  color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,

                    }}>

                        {dayjs(invite.createdAt).format("ddd MMM D, HH:mm")}
                    </Typography>
      
                    <Typography variant='subtitle1' fontSize={'14px'}  color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,

                    }}>

                        {invite.Amount  > 0 ? `NGN${invite.Amount}` : "No price available" }
                    </Typography>
                    <Typography variant='subtitle1' color={getColor()} textAlign={'center'} sx={{
                        mt: 1,
                        mb: 2,

                    }}

                    >
                        {invite.Status}
                    </Typography>
                    <div style={{
                        padding: '1em',
                        borderRadius: '24px',
                        backgroundColor: '#F8F8FA',
                        marginBottom: '2em'
                    }}>
                        <Typography fontWeight={'bold'}>
                        Description
                        </Typography>

                        <Typography variant='subtitle1' color={'#6B779A'}>
                            {invite.Description}
                        </Typography>
                    </div>



                    <div>
                        <Typography fontWeight={'bold'}>
                            Contractor
                        </Typography>
                        <ContractorListWidget contractor={invite!.Contractor as Contractor} />
                    </div>

                    <div>
                        <Typography fontWeight={'bold'}>
                            Patient
                        </Typography>
                        <PatientListWidget patient={invite!.Patient as Patient} />
                    </div>

                    <AppLink to={ROUTES.ADMIN_BASE +  "/requests/view/" + (invite.Request as number)}>
                        View Request
                    </AppLink>
                </Paper >
            </Centered>
        )
    }

export default InviteView;
